import { GraphQLEnumType } from 'graphql';

export const SFTPConnectionStatus = {
  SUCCESS: 'SUCCESS',
  AUTH_FAILURE: 'AUTH_FAILURE',
  WRONG_PORT_FAILURE: 'WRONG_PORT_FAILURE',
  HOST_NOT_REACHABLE_FAILURE: 'HOST_NOT_REACHABLE_FAILURE',
  FINGERPRINT_CHANGED: 'FINGERPRINT_CHANGED',
  FAILURE: 'FAILURE',
};
const SFTPConnectionStatusType = new GraphQLEnumType({
  name: 'SFTPConnectionStatus',
  description: 'An enumeration of status types for SFTP connections',
  values: {
    [SFTPConnectionStatus.SUCCESS]: { value: SFTPConnectionStatus.SUCCESS, description: 'Succeeded status' },
    [SFTPConnectionStatus.AUTH_FAILURE]: { value: SFTPConnectionStatus.AUTH_FAILURE, description: 'Authentication failure status' },
    [SFTPConnectionStatus.WRONG_PORT_FAILURE]: { value: SFTPConnectionStatus.WRONG_PORT_FAILURE, description: 'Wrong port failure status' },
    [SFTPConnectionStatus.HOST_NOT_REACHABLE_FAILURE]: {
      value: SFTPConnectionStatus.HOST_NOT_REACHABLE_FAILURE,
      description: 'Host not reachable failure status',
    },
    [SFTPConnectionStatus.FINGERPRINT_CHANGED]: {
      value: SFTPConnectionStatus.FINGERPRINT_CHANGED,
      description:
        'Status that reflects the fact that the fingerprint that was once confirmed for this host has now changed and needs to be re-confirmed',
    },
    [SFTPConnectionStatus.FAILURE]: { value: SFTPConnectionStatus.FAILURE, description: 'Unknown failure status' },
  },
});
export default SFTPConnectionStatusType;
